export default {
	root: ({ props, context }) => ({
		class: [
			"relative",

			// Alignment
			"flex items-center justify-center",
			"px-3 sm:px-4 py-1.5",

			//Color
			{
				"bg-white ": !props.modelValue,
				"border-surface-200 dark:border-surface-700 ":
					!props.modelValue && !props.invalid,
				"text-olive/75": !props.modelValue,
				"bg-olive border-olive text-white": props.modelValue,
			},

			// States
			{
				"hover:text-olive hover:bg-beige/50":
					!props.disabled && !props.modelValue,
				"focus:outline-none focus:outline-offset-0 focus-visible:ring-1 focus-visible:ring-olive-500 dark:focus-visible:ring-olive-400 rounded":
					!props.disabled,
			},

			// Invalid State
			{ "border-red dark:border-red-400": props.invalid },

			// Before
			"before:absolute before:left-1 before:top-1 before:w-[calc(100%-0.5rem)] before:h-[calc(100%-0.5rem)] before:rounded-[4px] before:z-0",

			// Transitions
			"transition-all duration-200",

			// Misc
			{
				"cursor-pointer": !props.disabled,
				"opacity-60 select-none pointer-events-none cursor-default":
				props.disabled,
			},

			// Misc
			"cursor-pointer",
			"select-none",
		],
	}),
	content: "relative items-center inline-flex justify-center gap-2",
	label: "font-semibold text-center w-full z-10 relative",
	icon: "relative z-10 mr-2",
}
